import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'avalia-dx-hub-customization',
});

export const architectureRouteRef = createSubRouteRef({
  id: 'avalia-dx-hub-customization:architecture',
  path: '/architecture',
  parent: rootRouteRef,
});

export const organizationRouteRef = createSubRouteRef({
  id: 'avalia-dx-hub-customization:organization',
  path: '/organization',
  parent: rootRouteRef,
});

export const slideShowRouteRef = createSubRouteRef({
  id: 'avalia-dx-hub-customization:slideshow',
  path: '/slideshow',
  parent: rootRouteRef,
});

export const analyticsRouteRef = createSubRouteRef({
  id: 'avalia-dx-hub-customization:analytics',
  path: '/analytics',
  parent: rootRouteRef,
});

export const initiativesRouteRef = createSubRouteRef({
  id: 'avalia-dx-hub-customization:initiatives',
  path: '/initiatives',
  parent: rootRouteRef,
});